module.exports = __webpack_public_path__ + "img/symmetry_en.96432e9.jpg";